import { InputLabel, Theme, styled } from '@material-ui/core';

const CustomInputLabel = styled(InputLabel)<Theme>(({ theme }) => ({
  position: 'inherit',
  top: 'auto',
  left: 'auto',
  display: 'inline-block',
  width: 'auto',
  transform: 'none',
  fontSize: theme.typography.bodyLg.fontSize,
  fontFamily: theme.config.secondaryFontFamily,
  color: theme.palette.grey['500'],
  textTransform: 'uppercase',
  marginRight: theme.spacing(1),
}));

export default CustomInputLabel;
